import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import "firebase/functions";
import { getConfig } from "./config";

firebase.initializeApp(getConfig().firebase)

export default firebase
